import { isFeatureEnabled, FEATURES } from './feature_checker';

export const redirectAfterSurgery = (history, match, account = null) => {
  // Accounts on the questionnaire builder use the dynamic flow, which works
  // through every questionnaire response due for the member.
  if (isFeatureEnabled(account, FEATURES.USE_QUESTIONNAIRE_BUILDER)) {
    history.push('/member/questionnaires');
    return;
  }

  if (!match?.uuid || !match?.account_slug) {
    history.push(`/member/conversations`);
    return;
  }

  history.push(`/member/mentor-matches/${match.uuid}/${match.account_slug}`);
};
